import { useEffect, useState } from "react";
import {
  type AuthDebugEvent,
  formatAuthDebugLog,
  getAuthDebugLog,
  subscribeAuthDebugLog,
} from "../lib/auth/debug-log";
import { Button } from "./ui/Button";

export function AuthDebugPanel() {
  const [events, setEvents] = useState<readonly AuthDebugEvent[]>(() => getAuthDebugLog());
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    return subscribeAuthDebugLog(() => setEvents([...getAuthDebugLog()]));
  }, []);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(formatAuthDebugLog());
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore
    }
  }

  return (
    <div className="mt-4 rounded-md border border-line bg-ground p-3 text-label">
      <div className="mb-2 flex items-center justify-between">
        <strong>Logs d'authentification ({events.length})</strong>
        <Button variant="ghost" size="sm" onClick={handleCopy}>
          {copied ? "✓ Copié" : "Copier"}
        </Button>
      </div>
      {events.length === 0 ? (
        <p className="m-0 text-muted">Aucun événement.</p>
      ) : (
        <ul className="m-0 flex max-h-96 flex-col gap-1 overflow-y-auto p-0">
          {events.map((e) => (
            <li
              key={`${e.ts}-${e.message}`}
              className={`list-none break-words font-mono ${e.level === "warn" ? "text-red-deep" : "text-ink"}`}
            >
              <span className="text-muted">{e.ts.slice(11, 19)}</span> {e.message}
              {e.details !== undefined && (
                <pre className="m-0 ml-4 whitespace-pre-wrap text-label text-muted">
                  {typeof e.details === "string" ? e.details : JSON.stringify(e.details, null, 2)}
                </pre>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
